import { z } from "zod";
import ContactUsService from "../../../../services/ContactUsService";
import { mapErrorsToFields } from "../../../../utils";
import { error } from "console";

const FormSchema = z.object({  
  name: z.string().min(1, "Name is required."),
  email: z
    .string()
    .min(1, "Email is required.")
    .email("Invalid email address."),
  subject: z.string().min(1, "Subject is required."),
  message: z.string().min(1, "Message is required."),
  replayed: z.boolean().optional(),
});

export type State = {
  success?: boolean;
  message?: string | null;
  errors?: {
    name?: string[];
    email?: string[];
    subject?: string[];
    message?: string[];
    replayed?: string[];
    general?: string[];
  };
  defaultValues?: {
    name?: string;
    email?: string;
    subject?: string;
    message?: string;
    replayed?: boolean;
  };
};
const api = new ContactUsService();
export async function updateContactUs(
  id: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {    
    name: formData.get("name"),
    email: formData.get("email"),
    subject: formData.get("subject"),
    message: formData.get("message"),
    replayed: formData.get("replayed") === "on" ? true : false,
  };
  const validatedFields = FormSchema.safeParse(defaultValues);
  console.log(validatedFields);
  if (!validatedFields.success) {
    console.log(validatedFields.error.flatten().fieldErrors);
    return {
      success: false,
      errors: mapErrorsToFields(validatedFields.error),
      message: "Missing Fields. Failed to Update Message.",
    };
  }

  try {
    const result = await api.setContactUsReplayed(id, defaultValues.replayed);
    if (result.status !== 200)
      return {
        errors: {},
        success: false,
        message: "Failed to update message.",
      };
    return { success: true, message: "Message updated successfully." };
  } catch (error) {
    return {
      success: false,
      message: "Failed to update message.",
    };
  }
}
